import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebaseConfig';
import Spinner from './Spinner'; // Importa tu componente Spinner

const PrivateRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <Spinner />; // Muestra el Spinner mientras se carga la autenticación
  }

  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
